/** Cache PDF đã tải (theo document id) để xem lại trong TTL — giảm gọi API / băng thông. */

const TTL_MS = 30 * 60 * 1000;
const MAX_ENTRIES = 40;

/** @type {Map<string, { buf: ArrayBuffer, exp: number }>} */
const cache = new Map();

function pruneExpired() {
  const now = Date.now();
  for (const [k, v] of cache) {
    if (now > v.exp) cache.delete(k);
  }
}

/** @returns {ArrayBuffer | null} */
export function getCachedPdfArrayBuffer(docId) {
  if (!docId) return null;
  pruneExpired();
  const e = cache.get(docId);
  if (!e || Date.now() > e.exp) {
    if (e) cache.delete(docId);
    return null;
  }
  return e.buf;
}

/** Lưu bản sao buffer (tránh dùng chung tham chiếu với Blob đang mở). */
export function putCachedPdfArrayBuffer(docId, arrayBuffer) {
  if (!docId || !(arrayBuffer instanceof ArrayBuffer)) return;
  pruneExpired();
  cache.set(docId, { buf: arrayBuffer.slice(0), exp: Date.now() + TTL_MS });
  while (cache.size > MAX_ENTRIES) {
    const k = cache.keys().next().value;
    cache.delete(k);
  }
}

export function invalidatePdfViewCache(docId) {
  if (docId == null || docId === "") cache.clear();
  else cache.delete(docId);
}
